import React from "react";

import { Box, Card, CardContent, Typography, useTheme } from "@mui/material";
// eslint-disable-next-line import/no-extraneous-dependencies
import Markdown from "react-markdown";

import ActionsList from "./ActionsList";
import InsightsModalManager, {
  ModalType,
} from "../../../../common/ModalManager";
import { Category } from "../../../../common/types";

interface ContentPostProp {
  title: string;
  content: string;
  refetch: () => void;
  category: Category;
}

export default function NewsletterPost({
  title,
  content,
  refetch,
  category,
}: ContentPostProp) {
  const [openInsightsModalManager, setOpenInsightsModalManager] =
    React.useState(false);
  const theme = useTheme();

  const handleOpenInsightsModalManager = () =>
    setOpenInsightsModalManager(true);

  const handleCopy = () => {
    navigator.clipboard.writeText(content);
  };

  return (
    <Box sx={{ mb: 2 }}>
      <InsightsModalManager
        open={openInsightsModalManager}
        setOpen={setOpenInsightsModalManager}
        modalType={ModalType.NEWSLETTER}
        modalTitle={`${title}`}
        objectValue={{ title: content }}
        values={[content]}
        refetch={refetch || (() => {})}
        category={category}
      />

      <Card
        sx={{
          width: "100%",
          background: "#fff",
          boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
          borderRadius: 2,
          p: 2,
          mb: 2,
          border: "none",
        }}
      >
        <CardContent sx={{ p: 0 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
              gap: 2,
              mb: 2,
            }}
          >
            {/* Title */}
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                color: theme.palette.text.primary,
                fontSize: "1rem",
                flex: 1,
              }}
            >
              {title}
            </Typography>

            {/* Action Buttons */}
            <ActionsList
              handleOpenInsightsModalManager={handleOpenInsightsModalManager}
              handleCopy={handleCopy}
            />
          </Box>

          {/* Content */}
          <Box
            sx={{
              "& p": {
                margin: "0.5rem 0",
                lineHeight: 1.6,
                color: theme.palette.text.primary,
              },
              "& h1, & h2, & h3, & h4, & h5, & h6": {
                margin: "1rem 0 0.5rem 0",
                fontWeight: 600,
                color: theme.palette.text.primary,
              },
              "& ul, & ol": {
                margin: "0.5rem 0",
                paddingLeft: "1.5rem",
              },
              "& li": {
                margin: "0.25rem 0",
              },
              "& blockquote": {
                borderLeft: `3px solid ${theme.palette.primary.main}`,
                paddingLeft: "1rem",
                margin: "1rem 0",
                fontStyle: "italic",
                color: theme.palette.text.secondary,
              },
            }}
          >
            <Markdown>{content}</Markdown>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}
